








































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VApp, VMain, VContainer, VRow, VCol, VCard, VSheet, VCardText, VCardTitle, VTimeline, VTimelineItem } from 'vuetify/lib';
import vuetify from '../plugins/vuetify';

interface Report {
  createdAt: Date;
  updatedAt: Date;
  id: number;
  content: string;
}

@Component({
  vuetify,
  components: {
    VApp, VMain, VContainer, VRow, VCol, VSheet, VCard, VCardText, VCardTitle, VTimeline, VTimelineItem,
  },
})
export default class FishingReports extends Vue {
  @Prop({ default: true}) private showTitle!: boolean;
  @Prop({ default: 'UWJFK6FVUA29Q' }) private merchantid!: string;
  @Prop({ default: '' }) private background!: string;

  private reports: Report[] = [];
  private readonly BACKEND = process.env.VUE_APP_BACKEND_HOST;

  public get title(): boolean {
    return this.showTitle;
  }

  public get bg(): string | undefined {
    if (this.background === '') {
      return undefined;
    }
    return this.background;
  }

  public async mounted() {
    const resp = await fetch(this.BACKEND + `/info/${this.merchantid}/reports`);
    this.reports = await resp.json();
    console.log(this.showTitle, this.background, this.bg);
  }
}
